export interface FieldModel {
  value: string;
  messages: string[];
  isTouched: boolean;
}

export function isValid(fieldState: FieldModel): boolean {
  return fieldState.messages.length === 0;
}
export function areAllValid(...fieldStates: FieldModel[]): boolean {
  let areValid = true;
  for (const fieldState of fieldStates) {
    areValid = isValid(fieldState);
    if (!areValid) {
      break;
    }
  }
  return areValid;
}

export function createInitialFieldModel(): FieldModel {
  return { value: "", messages: [], isTouched: false };
}
